import styles from './InlineInputs.module.css'

interface TimeInputProps {
  value: number
  onChange: (value: number) => void
  error?: boolean
}

export const TimeInput = ({ value, onChange, error }: TimeInputProps) => (
  <span className={`${styles.inlineInput} ${error ? styles.inlineInputError : ''}`}>
    <span className={styles.inputSection}>
      <input
        className={styles.input}
        type="number"
        min={1}
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
      />
    </span>
    <span className={styles.unitSection}>
      <span className={styles.unit}>mins</span>
    </span>
  </span>
)

interface DistanceInputProps {
  value: number
  onChange: (value: number) => void
  error?: boolean
}

export const DistanceInput = ({ value, onChange, error }: DistanceInputProps) => (
  <span className={`${styles.inlineInput} ${error ? styles.inlineInputError : ''}`}>
    <span className={styles.inputSection}>
      <input
        className={styles.input}
        type="number"
        min={1}
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
      />
    </span>
    <span className={styles.unitSection}>
      <span className={styles.unit}>km</span>
    </span>
  </span>
)
